import { AuthStore } from './AuthStore';
import EventPhotoStore from './EventPhotoStore';
import RegistrationStore from './RegistrationStore';
import SpinnerStore from './SpinnerStore';
import WizardStore from './WizardStore';
import StudioConfigStore from './StudioConfigStore';
import PopupStore from './PopupStore';
import SuggestionStore from './SuggestionStore';
import React from 'react';

export default class RootStore {
  public spinnerStore: SpinnerStore;
  public wizardStore: WizardStore;
  public registrationStore: RegistrationStore;
  public eventPhotoStore: EventPhotoStore;
  public authStore: AuthStore;
  public studioConfigStore: StudioConfigStore;
  public popupStore: PopupStore;
  public suggestionStore: SuggestionStore;

  constructor() {
    // Create stores that don't depend on others first
    this.spinnerStore = new SpinnerStore();
    this.authStore = new AuthStore();
    this.studioConfigStore = new StudioConfigStore();
    this.popupStore = new PopupStore();
    
    // Create wizardStore with authStore reference
    this.wizardStore = new WizardStore();
    // Make the wizardStore use the singleton authStore
    this.wizardStore.authStore = this.authStore;
    
    // Create stores that depend on others
    this.registrationStore = new RegistrationStore(this);
    this.eventPhotoStore = new EventPhotoStore(this);
    this.suggestionStore = new SuggestionStore(this);
    
    // Connect the registration store to the wizard store
    this.wizardStore.registrationStore = this.registrationStore;
    
    // After all stores are initialized, check for authenticated user
    setTimeout(() => this.wizardStore.checkInitialAuth(), 0);
  }
}

export const RootStoreContext = React.createContext<RootStore>(undefined);